<script>
	import _ from 'lodash'
	import uiInputHandler from './ui-input-handler.vue'
	import md5 from 'js-md5'

	export default {
		components: { uiInputHandler },
		props: {
			value: {
				type: [Array, String, Number, Object, Boolean]
			},
			formArchetype: {
				type: [Array],
				required: true
			},
			source: {
				type: [Array, Object],
				required: true
			}
		},
		computed: {
			workingValueMD5(){
				return md5(JSON.stringify(this.workingValue))
			},
			valueMD5(){
				return md5(JSON.stringify(this.value))
			}
		},
		data: () => {
			return {
				lodash: _,
				workingValue: {}
			}
		},
		watch: {
			workingValueMD5(){
				if(this.workingValueMD5 != this.valueMD5){
					this.$emit('input', _.cloneDeep(this.workingValue))
					this.$emit('updated')
				}
			}
		},
		beforeMount(){
			this.workingValue = _.cloneDeep(this.value)
		}
	}
</script>

<template>
	<div class="ui-form-fromarchetype">

        <template v-for="(fArch, $index) in formArchetype">

            <div class="separator" :key="$index" v-if="fArch == null">
                <hr />
            </div>

            <template v-else-if="lodash.isArray(fArch) || fArch.type != 'hidden'">
                
                <b-row :key="$index" v-if="lodash.isArray(fArch)">

                    <b-col v-for="fArchInRow in fArch" :key="fArchInRow.key">
                        <ui-input-handler :ref="fArchInRow.key" :f-arch="fArchInRow" v-model="workingValue[fArchInRow.key]" :source="source" />
                    </b-col>

                </b-row>

                <b-row v-else-if="fArch.type != 'hidden'" :key="fArch.key" >

                    <b-col>
                        <ui-input-handler :ref="fArch.key" :f-arch="fArch" v-model="workingValue[fArch.key]" :source="source" />
                    </b-col>

                </b-row>
                
            </template>

        </template>

	</div>
</template>